export default __webpack_public_path__ + "static/media/emergencia_1.a2c48311.svg";